"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractParamsProvider = void 0;
const utf8_1 = require("@ethersproject/strings/lib/utf8");
const bytes_1 = require("@ethersproject/bytes");
const utils_1 = require("ethers/lib/utils");
const index_1 = require("../index");
class ContractParamsProvider {
    constructor(requestParams, urls) {
        this.requestParams = requestParams;
        if (!urls) {
            requestParams.urls = (0, index_1.getUrlsForDataServiceId)(requestParams);
        }
    }
    async getPayloadData() {
        const payloadHex = await this.requestPayload(this.requestParams);
        return Array.from((0, utils_1.arrayify)(payloadHex));
    }
    getHexlifiedFeedIds() {
        return this.getDataFeedIds().map((feed) => (0, bytes_1.hexlify)((0, utf8_1.toUtf8Bytes)(feed)));
    }
    getDataFeedIds() {
        if (!this.requestParams.dataFeeds) {
            throw new Error("That invocation requires non-empty dataFeeds");
        }
        return this.requestParams.dataFeeds;
    }
    async requestPayload(requestParams) {
        return "0x" + (await (0, index_1.requestRedstonePayload)(requestParams));
    }
}
exports.ContractParamsProvider = ContractParamsProvider;
//# sourceMappingURL=ContractParamsProvider.js.map